import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "label"]

  connect() {
    this._onOutsideClick = (e) => {
      if (!this.element.contains(e.target)) this.close()
    }
  }

  toggle() {
    const hidden = this.panelTarget.classList.contains("hidden")
    if (hidden) {
      this.panelTarget.classList.remove("hidden")
      document.addEventListener("click", this._onOutsideClick)
    } else {
      this.close()
    }
  }

  close() {
    this.panelTarget.classList.add("hidden")
    document.removeEventListener("click", this._onOutsideClick)
  }

  select(event) {
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = event.currentTarget.dataset.label
    }
    this.close()
    this.element.closest("form").requestSubmit()
  }

  disconnect() {
    document.removeEventListener("click", this._onOutsideClick)
  }
}
